<template>
  <div id="privacy" v-if="compiledHtml !== ''">
    <div class="paragraph">
      <div class="head">{{ $t('Privacy.title') }}</div>
      <div class="body">
        <div class="content" v-html="compiledHtml">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Privacy',
  metaInfo () {
    return {
      title: 'พร้อมไป ไปถึงทุกที่ไม่มีพลาด',
      meta: [
        {
          name: 'description',
          content: 'การระบุตำแหน่งสถานที่โดยใช้ตัวเลข (Map code) แทนข้อมูลที่อยู่ ชื่อสถานที่ พิกัด Latitude Longitude หรือข้อมูลอื่นที่เกี่ยวข้องกับสถานที่นั้น'
        },
        {
          name: 'keywords',
          content: 'พร้อมไป, PromptPai'
        },
        {
          property: 'fb:app_id',
          content: '148173948530677'
        },
        {
          property: 'og:site_name',
          content: 'PromptPai'
        },
        {
          property: 'og:image',
          content: 'https://promptpai.com/static/image/promptpai_app_icon_xxxhdpi.png'
        },
        {
          property: 'og:image:type',
          content: 'image/png'
        },
        {
          property: 'og:url',
          content: 'https://promptpai.com'
        },
        {
          property: 'og:description',
          content: 'การระบุตำแหน่งสถานที่โดยใช้ตัวเลข (Map code) แทนข้อมูลที่อยู่ ชื่อสถานที่ พิกัด Latitude Longitude หรือข้อมูลอื่นที่เกี่ยวข้องกับสถานที่นั้น'
        },
        {
          property: 'og:title',
          content: 'พร้อมไป ไปถึงทุกที่ไม่มีพลาด'
        }
      ]
    }
  },
  data () {
    return {
      input: ''
    }
  },
  computed: {
    compiledHtml () {
      var self = this
      return self.input
    }
  },
  created () {
    var self = this
    self.loadFile()
  },
  mounted () {
    document.querySelector('#app').scrollTop = '0px'
  },
  methods: {
    loadFile () {
      axios({
        method: 'get',
        url: '/static/privacy.html'
      }).then(result => {
        this.input = result.data
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style>
  #privacy {
    padding: 16px;
    display: flex;
    flex-direction: column;
  }

  #privacy .paragraph {
    width: 100%;
    min-width: calc(320px - 32px);
    max-width: 1024px;
    margin: 40px auto 0px auto;
  }

  #privacy .paragraph > .head {
    font-family: Prompt;
    font-size: 22px;
    color: rgb(255, 255, 255);
  }

  #privacy .paragraph > .body {
    background-color: rgba(255, 255, 255, 0.95);
    border-radius: 10px;
    padding: 16px;
    text-align: left;
    line-height: 1.75;
  }

  #privacy .paragraph > .body * {
    line-height: 1.75;
  }

  #privacy .paragraph > .body h3 {
    font-size: 22px;
    margin: 32px 0px 8px 0px;
  }

  #privacy .paragraph > .body p {
    margin: 8px 0px;
  }

  #privacy .paragraph > .body ul {
    margin: 8px 0px;
  }

  #privacy .paragraph > .body li {
  }

  .paragraph > .body strong {
  }

  #privacy .primary-color {
    color: rgb(34, 84, 156);
  }

  #privacy .bold {
    font-weight: bold;
  }

  #privacy .link {
    cursor: pointer;
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Privacy.vue